import type { ManagedPoiContent } from '@/services/dto';
import type { PoiContentSlide } from '@/types/shop';

const isLanguageContentEmpty = (data: (ManagedPoiContent | undefined)[], lang: string) => {
  return data.every(item => {
    const value = item?.content?.[lang];
    return value === undefined || value === null || String(value).trim() === "";
  });
}

export const isMinimalPoiSlide = (poiContentSlide: PoiContentSlide | null | undefined, language: string): boolean => {
    if (!poiContentSlide) {
        return false;
    }

    return isLanguageContentEmpty(poiContentSlide.data.managedContents ?? [], language);
};
